/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Modal,
  Typography,
  Row,
  Col,
  Divider,
  Space,
  Tag,
  Input,
  Button,
  Form,
  Tabs,
} from 'antd';
import {
  UserOutlined,
  MailOutlined,
  HomeOutlined,
  IdcardOutlined,
  FileDoneOutlined,
} from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;
const { TabPane } = Tabs;
const { TextArea } = Input;

const getBadgeStatus = (estado) => {
  switch (estado) {
    case 'Activa':
      return 'default';
    case 'Autorizada':
    case 'Cita para Entrevista':
      return 'processing';
    case 'Cancelada':
      return 'error';
    case 'En Reclutamiento':
    case 'En Evaluación':
      return 'warning';
    case 'Seleccionado(a)':
    case 'Contratado(a)':
      return 'success';
    default:
      return 'default';
  }
};

export default function CandidatoModal({
  open, onClose, candidato, vacante,
}) {
  const [form] = Form.useForm();
  const [editandoNota, setEditandoNota] = useState(false);
  const [nota, setNota] = useState(candidato?.nota || '');

  if (!candidato || !vacante) return null;

  const handleGuardarNota = () => {
    form.validateFields().then((values) => {
      setNota(values.nota);
      setEditandoNota(false);
    });
  };

  return (
    <Modal
      title={(
        <>
          <UserOutlined style={{ marginRight: 8 }} />
          Ficha de
          {' '}
          {candidato.nombre}
        </>
      )}
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      bodyStyle={{ paddingTop: 12 }}
    >
      <Tabs defaultActiveKey="info">
        <TabPane tab="Información General" key="info">
          <Tabs defaultActiveKey="personales" type="card">
            <TabPane tab="Datos Personales" key="personales" icon={<UserOutlined />}>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Text type="secondary">Nombre Completo</Text>
                  <Paragraph>{`${candidato.nombre} ${candidato.apellidoPaterno} ${candidato.apellidoMaterno}`}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Género</Text>
                  <Paragraph>{candidato.genero}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Fecha de Nacimiento</Text>
                  <Paragraph>{candidato.fechaNacimiento}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Edad</Text>
                  <Paragraph>{candidato.edad}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Estado Civil</Text>
                  <Paragraph>{candidato.estadoCivil}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">¿Tiene hijos?</Text>
                  <Paragraph>{candidato.conHijos}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Nacionalidad</Text>
                  <Paragraph>{candidato.nacionalidad}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">País</Text>
                  <Paragraph>{candidato.pais}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Estado</Text>
                  <Paragraph>{candidato.estado}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Municipio</Text>
                  <Paragraph>{candidato.municipio}</Paragraph>
                </Col>
              </Row>
            </TabPane>

            <TabPane tab="Contacto" key="contacto" icon={<MailOutlined />}>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Text type="secondary">Email</Text>
                  <Paragraph copyable>{candidato.email || 'N/A'}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Teléfono Móvil</Text>
                  <Paragraph>{candidato.telefonoMovil || 'N/A'}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Teléfono Casa</Text>
                  <Paragraph>{candidato.telefonoCasa || 'N/A'}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Fuente de Reclutamiento</Text>
                  <Paragraph>{candidato.fuenteReclutamiento}</Paragraph>
                </Col>
              </Row>
            </TabPane>

            <TabPane tab="Domicilio" key="domicilio" icon={<HomeOutlined />}>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Text type="secondary">Código Postal</Text>
                  <Paragraph>{candidato.codigoPostal}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Estado</Text>
                  <Paragraph>{candidato.estadoDireccion}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Municipio</Text>
                  <Paragraph>{candidato.municipioDireccion}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Colonia</Text>
                  <Paragraph>{candidato.colonia}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Calle</Text>
                  <Paragraph>{candidato.nombreVialidad}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Número Exterior</Text>
                  <Paragraph>{candidato.numeroExterior}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Número Interior</Text>
                  <Paragraph>{candidato.numeroInterior || 'N/A'}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Descripción de Ubicación</Text>
                  <Paragraph>{candidato.descripcionUbicacion || 'No especificada'}</Paragraph>
                </Col>
              </Row>
            </TabPane>

            <TabPane tab="Identificación" key="identificacion" icon={<IdcardOutlined />}>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Text type="secondary">Tipo de Identificación</Text>
                  <Paragraph>{candidato.tipoIdentificacion}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Número</Text>
                  <Paragraph>{candidato.numeroIdentificacion}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">CURP</Text>
                  <Paragraph copyable>{candidato.curp}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">RFC</Text>
                  <Paragraph copyable>{candidato.rfc}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Tipo Seguridad Social</Text>
                  <Paragraph>{candidato.tipoSeguridadSocial || 'N/A'}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">NSS</Text>
                  <Paragraph>{candidato.numeroSeguridadSocial || 'N/A'}</Paragraph>
                </Col>
                <Col span={12}>
                  <Text type="secondary">Registro Patronal</Text>
                  <Paragraph>{candidato.registroPatronal || 'N/A'}</Paragraph>
                </Col>
              </Row>
            </TabPane>

            <TabPane tab="Documentos" key="documentos" icon={<FileDoneOutlined />}>
              <ul style={{ paddingLeft: 24 }}>
                {(candidato.documentosEntregados || []).map((doc) => (
                  <li key={doc}>
                    <Text>{doc}</Text>
                  </li>
                ))}
              </ul>
            </TabPane>
          </Tabs>
        </TabPane>

        {/* <TabPane tab="Vacante Relacionada" key="vacante">
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Text type="secondary">Vacante</Text>
              <Paragraph>
                {vacante.vacanteCodigo}
                {' '}
                -
                {' '}
                {vacante.vacantePlaza}
              </Paragraph>
            </Col>
            <Col span={12}>
              <Text type="secondary">Puesto</Text>
              <Paragraph>{vacante.vacantePuesto}</Paragraph>
            </Col>
            <Col span={12}>
              <Text type="secondary">Plaza</Text>
               AQUI SE DEBE CAMBIAR POR LA PLAZA
              <Paragraph>{vacante.vacantePuesto}</Paragraph>
            </Col>
            <Col span={12}>
              <Text type="secondary">Tipo de Empleado</Text>
              <Paragraph>{vacante.empleadoTipo}</Paragraph>
            </Col>
            <Col span={12}>
              <Text type="secondary">Motivo</Text>
              <Paragraph>{vacante.vacanteMotivo}</Paragraph>
            </Col>
            <Col span={12}>
              <Text type="secondary">Estatus</Text>
              {' '}
              <Tag color={getBadgeStatus(vacante.vacanteEstatus)}>{vacante.vacanteEstatus}</Tag>
            </Col>
            <Col span={24}>
              <Text type="secondary">Pruebas Asignadas</Text>
              <br />
              <Space wrap>{vacante.pruebasAsignadas?.map((p) => <Tag key={p}>{p}</Tag>)}</Space>
            </Col>
          </Row>
          <Divider />
          <Title level={5}>Solicitante</Title>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Text type="secondary">Oficio de Solicitud</Text>
              <Paragraph>
                {vacante.solicitudFolio}
                {' '}
                /
                {' '}
                {vacante.solicitudFecha.replace(/\//g, '-')}
              </Paragraph>
            </Col>
            <Col span={12}>
              <Text type="secondary">Nombre</Text>
              <Paragraph>{vacante.solicitanteNombre}</Paragraph>
            </Col>
            <Col span={12}>
              <Text type="secondary">Puesto</Text>
              <Paragraph>{vacante.solicitantePuesto}</Paragraph>
            </Col>
            <Col span={12}>
              <Text type="secondary">Área</Text>
              <Paragraph>
                {vacante.solicitanteAreaCodigo}
                {' '}
                -
                {' '}
                {vacante.solicitanteAreaNombre}
              </Paragraph>
            </Col>
          </Row>
        </TabPane> */}

        <TabPane tab="Notas del Reclutador" key="notas">
          {editandoNota ? (
            <Form layout="vertical" form={form} initialValues={{ nota }}>
              <Form.Item name="nota" label="Notas del Reclutador" rules={[{ required: true }]}>
                <TextArea rows={5} />
              </Form.Item>
              <Space>
                <Button onClick={() => setEditandoNota(false)}>Cancelar</Button>
                <Button type="primary" onClick={handleGuardarNota}>Guardar</Button>
              </Space>
            </Form>
          ) : (
            <div>
              <Paragraph>{nota || 'Sin notas registradas.'}</Paragraph>
              <Button type="link" onClick={() => setEditandoNota(true)}>Editar Nota</Button>
            </div>
          )}
        </TabPane>
      </Tabs>
    </Modal>
  );
}
